import * as Icons from "@nova/component-icons"
import { DropBoxV2 } from "panels/content/top-bar/TODO-put-in-package/dropbox/DropBoxV2"
import { allowedFileExtensions, footerHeight, navbarHeight } from "@nova/constants"
import { AddMoreDropBox } from "panels/content/top-bar/TODO-put-in-package/dropbox/AddMoreDropBox"
import { ScrollableArea } from "@nova/component-scrollable-area"
import { splitExtension } from "@nova/util-strings"
import classNames from "classnames"
import { FirePerimeterFileMetadataEntry } from "plugins/DrawPerimeter/uploads/FirePerimeterFileMetadataEntry"
import {
    firePerimeterAddMoreFilesTitle,
    firePerimeterNoPolygonsErrorTitle,
    firePerimeterUploadTitle,
} from "plugins/DrawPerimeter/constants"
import { AlertContainer } from "@nova/component-alert-container"
import { useFirePerimeterMethodUploadFiles } from "plugins/DrawPerimeter/useFirePerimeterMethodUploadFiles"

export const InspectorPanelFirePerimeterUpdateUpload = () => {
    const { files, hasProcessingError, deleteFileAtIndex, handleNewItems, hasFiles } =
        useFirePerimeterMethodUploadFiles()

    return (
        <div className="border-t border-gray-700 px-4 py-2">
            {!hasFiles ? (
                <DropBoxV2
                    canAcceptMultiple
                    allowedFileExtensions={allowedFileExtensions["FirePerimeter"]}
                    onNewItems={handleNewItems}
                    isProcessing={false}
                    title={
                        !hasProcessingError
                            ? firePerimeterUploadTitle
                            : firePerimeterNoPolygonsErrorTitle
                    }
                    hasProcessingError={hasProcessingError}
                />
            ) : (
                <div
                    className="flex-1 flex flex-col overflow-y-hidden min-h-0 gap-2 -mr-3"
                    style={{
                        maxHeight: `calc(${window.innerHeight - navbarHeight - footerHeight}px - 11.625rem)`,
                    }}
                >
                    <ScrollableArea shouldPreventScrollbarShifting={true} className="pr-3">
                        {files.map((file, i) => {
                            const [fileName, extension] = splitExtension(file.name)

                            return (
                                <div
                                    className={classNames("relative select-none", {
                                        "mt-2 pt-2 border-t border-gray-700": i > 0,
                                    })}
                                    key={file.name + i}
                                >
                                    {/* File Name & Delete File Button */}
                                    <div className="flex justify-between items-center gap-1 h-5">
                                        {/* File Name */}
                                        <span className="flex items-center overflow-hidden whitespace-nowrap">
                                            <h5 className="text-gray-0 overflow-hidden text-ellipsis whitespace-nowrap">
                                                {fileName}
                                            </h5>
                                            {extension && (
                                                <h5 className="text-gray-0 flex-shrink-0">
                                                    .{extension}
                                                </h5>
                                            )}
                                        </span>

                                        {/* Delete File Button */}
                                        <Icons.SmallIcon
                                            Icon={Icons.Trash}
                                            className="text-red-500 hover:text-red-200 active:text-red-700 cursor-pointer"
                                            onClick={() => deleteFileAtIndex(i)}
                                        />
                                    </div>

                                    {/* File Metadata */}
                                    <div className="flex flex-col gap-1 mt-2">
                                        <FirePerimeterFileMetadataEntry
                                            title="Perimeter Length"
                                            value={file.length}
                                        />
                                        <FirePerimeterFileMetadataEntry
                                            title="Perimeter Area"
                                            value={file.area}
                                        />
                                        <FirePerimeterFileMetadataEntry
                                            title="File Size"
                                            value={file.size}
                                        />
                                        <FirePerimeterFileMetadataEntry
                                            title="Date Created"
                                            value={file.dateCreated}
                                        />
                                    </div>

                                    {/* Info Message (if file is an unclosed polygon) */}
                                    {file.hasLine && (
                                        <AlertContainer
                                            type="info"
                                            title="Line file selected."
                                            body="We'll automatically close it into a polygon."
                                            className="mt-2"
                                        />
                                    )}
                                </div>
                            )
                        })}
                    </ScrollableArea>

                    <AddMoreDropBox
                        canAcceptMultiple
                        allowedFileExtensions={allowedFileExtensions["FirePerimeter"]}
                        onNewItems={handleNewItems}
                        isProcessing={false}
                        className="mr-3"
                        title={
                            !hasProcessingError
                                ? firePerimeterAddMoreFilesTitle
                                : firePerimeterNoPolygonsErrorTitle
                        }
                        hasProcessingError={hasProcessingError}
                    />
                </div>
            )}
        </div>
    )
}
